/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { Map, List, Record } from 'immutable';
import { actionTypes } from '../actions/platformUseCase';

export const AccountPlatformUseCase = new Record(
  {
    accountId: 0,
    platform: {
      id: 0,
      description: '',
      code: '',
      platformType: '',
    },
    useCase: {
      code: '',
      description: '',
      definition: '',
    },
  },
  'AccountPlatformUseCase'
);

export const UseCase = new Record(
  {
    code: '',
    description: '',
    definition: '',
  },
  'UseCase'
);

const platformUseCaseMap = new Map({
  accountPlatformUseCaseList: new List(),
  useCases: new List(),
});

const initialState = platformUseCaseMap;

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.PLATFORM_USE_CASE_SUBSCRIBE_SUCCESS:
    case actionTypes.PLATFORM_USE_CASE_UNSUBSCRIBE_SUCCESS:
    case actionTypes.PLATFORM_USE_CASE_SUBSCRIBED_FETCH_SUCCESS: {
      const acctPUCArray = action.accountPlatformUseCases.map(
        accPUC => new AccountPlatformUseCase(accPUC)
      );
      const acctPUCList = new List(acctPUCArray);
      return state.merge({ accountPlatformUseCaseList: acctPUCList });
    }
    case actionTypes.USE_CASES_FETCH_SUCCESS: {
      const useCaseArray = action.useCases.map(useCase => new UseCase(useCase));
      const useCaseList = new List(useCaseArray);
      return state.merge({ useCases: useCaseList });
    }
    default: {
      return state;
    }
  }
}
